import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';

import { REACT_APP_REST_URL } from '../../../config';
import useStyles from '../styles';

interface ICardCertificateProps {
  printRef: React.RefObject<HTMLDivElement> | null;
  accessKey: string;
}

const CardCertificate: FC<ICardCertificateProps> = ({
  printRef,
  accessKey,
}) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <>
      <Helmet titleTemplate="%s" defer={false}>
        <title>
          {intl.formatMessage({ id: 'common.card.title.certificate' })}
        </title>
      </Helmet>
      <div className={classes.printablePage} ref={printRef}>
        <img
          className={classes.vaccineCertImage}
          src={`${REACT_APP_REST_URL}/c/${accessKey}`}
          alt="VACCINE CERT"
        />
      </div>
    </>
  );
};

export default CardCertificate;
